<script lang="ts">
import GuestLayout from "@/layouts/GuestLayout.vue"

export default { layout: GuestLayout }
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref } from "vue"

import { ICON } from "@/lib/icons"
import { accountInvitePath, joinAccountPath, newSessionPath } from "@/routes"

const props = defineProps<{
  account_name: string
  invited_by: string
  authenticated: boolean
  token: string
}>()

const joining = ref(false)
const joinAccountUrl = joinAccountPath(props.token)

function join() {
  joining.value = true
  router.post(
    accountInvitePath(props.token),
    {},
    {
      onFinish: () => (joining.value = false),
    },
  )
}
</script>

<template>
  <Head :title="`Join ${account_name}`" />

  <div class="flex flex-col items-center gap-6 text-center">
    <div>
      <h1 class="text-highlighted text-xl font-bold">Join {{ account_name }}</h1>
      <p class="text-muted mt-1 text-sm">{{ invited_by }} invited you to share their inventory.</p>
    </div>

    <template v-if="authenticated">
      <UButton :icon="ICON.check" label="Join" size="lg" block :loading="joining" @click="join" />
    </template>

    <template v-else>
      <UButton label="Sign in to join" :to="newSessionPath()" block />
      <p class="text-muted text-sm">
        Don't have an account?
        <UButton :to="joinAccountUrl" variant="link" label="Create one" size="sm" />
      </p>
    </template>
  </div>
</template>
